var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudioLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2lvscg8uha",
    x1: "-7.466%",
    x2: "37.22%",
    y1: "-13.904%",
    y2: "59.362%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1EE2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006FD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bwq1f5ihlb",
    x1: "0%",
    x2: "100%",
    y1: ".172%",
    y2: "99.828%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8C57FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C800FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n1a65yfh6c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "97.59%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8C57FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C800FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "206l3u1aid",
    width: "121.9%",
    height: "128.7%",
    x: "-14.1%",
    y: "-14.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.211390399 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rfktaamgof",
    width: "121.9%",
    height: "128.7%",
    x: "-14.1%",
    y: "-14.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.211390399 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "0pv2w0y08h",
    width: "111.8%",
    height: "118.2%",
    x: "-5.9%",
    y: "-9.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.135586504 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "da3a8a9dde",
    d: "M0 31.918L31.973 7.51 31.973 31.918z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nx6v2ixtdg",
    d: "M0 24.408L31.973 0 31.973 24.408z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kkbz0gtdfi",
    d: "M26.394 10.45L34.858 21.467 17.931 21.467z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#2lvscg8uha)",
    d: "M.808 0h30.357c.446 0 .808.362.808.808V31.11c0 .447-.362.809-.808.809H.808c-.446 0-.808-.362-.808-.809V.81C0 .361.362 0 .808 0z",
    transform: "translate(-13 -18) translate(16 20.062)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bwq1f5ihlb)",
    d: "M.808 0h30.357c.446 0 .808.362.808.808V31.11c0 .447-.362.809-.808.809H.808c-.446 0-.808-.362-.808-.809V.81C0 .361.362 0 .808 0z",
    transform: "translate(-13 -18) translate(16 20.062)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n1a65yfh6c)",
    d: "M33.947 6.094v19.73c0 .083.04.162.106.213l6.834 5.22c.236.18.574.135.755-.102.072-.094.11-.209.11-.327V1.09c0-.297-.24-.538-.538-.538-.118 0-.233.038-.327.11l-6.834 5.22c-.066.05-.106.13-.106.213z",
    transform: "translate(-13 -18) translate(16 20.062)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.265,
    transform: "translate(-13 -18) translate(16 20.062)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#206l3u1aid)",
    xlinkHref: "#da3a8a9dde"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#da3a8a9dde"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.199,
    transform: "translate(-13 -18) translate(16 20.062) matrix(1 0 0 -1 0 24.408)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#rfktaamgof)",
    xlinkHref: "#nx6v2ixtdg"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#nx6v2ixtdg"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.196 5.057v3.247H12.339v5.845h9.836v3.062H12.34v6.449h10.857v3.247H8.814V5.057h14.382z",
    transform: "translate(-13 -18) translate(16 20.062)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioLogo);
export default __webpack_public_path__ + "static/media/studio-logo.26d1ecf7.svg";
export { ForwardRef as ReactComponent };